module.exports = __webpack_public_path__ + "img/menu-icon-toggle.18d53aac.svg";